import moment from 'moment';

export const formatDateTimestamp = (
  timestamp: number = Math.floor(Date.now() / 1000),
  format = 'Do MMM YYYY',
  isMilliseconds = false,
): string => (isMilliseconds ? moment(timestamp).format(format) : moment.unix(timestamp).format(format));
